import { render, staticRenderFns } from "./OpenVip.vue?vue&type=template&id=0439dffd&scoped=true&"
import script from "./OpenVip.vue?vue&type=script&lang=js&"
export * from "./OpenVip.vue?vue&type=script&lang=js&"
import style0 from "./OpenVip.vue?vue&type=style&index=0&id=0439dffd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0439dffd",
  null
  
)

export default component.exports